/// <amd-module name="TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Stores/StoresHub" />
import { ActionsHub } from "TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Actions/ActionsHub";
import { AboutProjectStore } from "TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Stores/AboutProjectStore";
import { PermissionsStore } from "TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Stores/PermissionsStore";
import { CurrentUserInfoStore } from "TFS/Views/ProjectOverviewPage/Shared/CurrentUserInfoStore";
import { ProjectBasicInfoStore } from "TFS/Views/ProjectOverviewPage/Shared/ProjectBasicInfoStore";

/**
 * A container to hold the multiple stores of project overview pivot
 */
export class StoresHub {
    public aboutProjectStore: AboutProjectStore;
    public permissionsStore: PermissionsStore;

    constructor(actionsHub: ActionsHub, public projectBasicInfoStore: ProjectBasicInfoStore, public currentUserInfoStore: CurrentUserInfoStore) {
        this.aboutProjectStore = new AboutProjectStore("aboutProjectStoreChangedEvent");
        actionsHub.aboutProjectDataLoaded.addListener(this.aboutProjectStore.loadAboutProject);
        actionsHub.aboutProjectDataLoadFailed.addListener(this.aboutProjectStore.loadAboutProjectFailed);

        actionsHub.projectTagsUpdated.addListener(this.aboutProjectStore.projectTagsUpdated);
        actionsHub.projectTagsUpdateStarted.addListener(this.aboutProjectStore.projectTagsUpdateStarted);
        actionsHub.projectTagsUpdateFailed.addListener(this.aboutProjectStore.projectTagsUpdateFailed);
        actionsHub.projectTagsNotUpdating.addListener(this.aboutProjectStore.projectTagsNotUpdating);

        actionsHub.allProjectTagsInCollectionLoaded.addListener(this.aboutProjectStore.loadAllProjectTagsInCollection);

        actionsHub.readmeSettingUpdated.addListener(this.aboutProjectStore.readmeSettingUpdated);
        actionsHub.readmeSettingUpdateFailed.addListener(this.aboutProjectStore.readmeSettingUpdateFailed);
        actionsHub.readmeSettingUpdateStarted.addListener(this.aboutProjectStore.readmeSettingUpdateStarted);
        actionsHub.readmeSettingNotUpdating.addListener(this.aboutProjectStore.readmeSettingNotUpdating);

        actionsHub.projectDescriptionUpdated.addListener(this.projectBasicInfoStore.projectDescriptionUpdated);
        actionsHub.projectDescriptionUpdateFailed.addListener(this.projectBasicInfoStore.projectDescriptionUpdateFailed);
        actionsHub.projectDescriptionUpdateStarted.addListener(this.projectBasicInfoStore.projectDescriptionUpdateStarted);
        actionsHub.projectDescriptionNotUpdating.addListener(this.projectBasicInfoStore.projectDescriptionNotUpdating);

        this.permissionsStore = new PermissionsStore("permissionsStoreChangedEvent");
        actionsHub.permissionsLoaded.addListener(this.permissionsStore.loadPermissions);
    }
}
